import { render } from "./ContentControls.vue?vue&type=template&id=767dfb20&scoped=true&ts=true"
import script from "./ContentControls.vue?vue&type=script&lang=ts"
export * from "./ContentControls.vue?vue&type=script&lang=ts"

import "./ContentControls.vue?vue&type=style&index=0&id=767dfb20&scoped=true&lang=css"

import exportComponent from "/app/purple__bee/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-767dfb20"]])

export default __exports__